export default __webpack_public_path__ + "static/media/risk-bars-negligible-dark.368b9b41.svg";